import axios from "axios";
import { format } from "date-fns";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshPromise = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    const skip = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (error.response?.status === 401 && !original._retry && !skip) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (e) {
        refreshPromise = null;
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const TZ = -new Date().getTimezoneOffset();
export const todayStr = () => format(new Date(), "yyyy-MM-dd");
export const daysAgoStr = (n) => format(new Date(Date.now() - n * 86400000), "yyyy-MM-dd");
export const daysAheadStr = (n) => format(new Date(Date.now() + n * 86400000), "yyyy-MM-dd");

const tzs = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
export const money = (v) => `TSh ${tzs.format(Math.round(Number(v || 0)))}`;
export const COMPANY = { name: "MATWIGA ENTERPRISES", address: "P.O. BOX 13812, DAR ES SALAAM", email: "mathewelias176@gmail.com", tin: "156-897-957", vrn: "40-305092-C" };
export const VAT_RATE = 0.18;
export const vatSplit = (total) => { const vat = Math.round((total * VAT_RATE / (1 + VAT_RATE)) * 100) / 100; return [total - vat, vat]; };
export const TRUCK_EXPENSE_CATEGORIES = ["Fuel", "Repairs & Service", "Tyres", "Driver allowance", "Tolls & Permits", "Insurance", "Other"];
export const qtyFmt = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
export const timeFmt = (iso) => format(new Date(iso), "HH:mm");
export const dateTimeFmt = (iso) => format(new Date(iso), "MMM d, HH:mm");

export const PAYMENT_METHODS = ["Cash", "Mobile Money", "Bank Transfer", "Card", "Credit"];
export const CASH_METHODS = PAYMENT_METHODS.filter((m) => m !== "Credit");

export async function downloadFile(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
export const EXPENSE_CATEGORIES = ["Rent", "Salaries & Wages", "Transport & Delivery", "Utilities", "Repairs & Maintenance", "Supplies", "Taxes & Licenses", "Meals", "Other"];
export const PRODUCT_CATEGORIES = ["Tools", "Plumbing", "Electrical", "Paint", "Fasteners", "Building Materials", "Roofing", "Timber", "Safety Gear", "General"];
export const UNITS = ["pcs", "box", "bag", "kg", "m", "ft", "litre", "roll", "sheet", "set", "pair", "carton"];
